import { token } from "@may-i/mash-design-system";
import { useLocation, useParams } from "react-router-dom";
import styled from "styled-components";
import { WorkflowTabs } from "~/widgets/gnb/WorkflowTabs";

export function WorkflowBar() {
  const { branchUid } = useParams();
  const location = useLocation();

  if (!branchUid) return null;

  return (
    <Bar>
      <WorkflowTabs branchUid={branchUid} currentPath={location.pathname} />
    </Bar>
  );
}

const Bar = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  height: var(--workflow-bar-height);
  padding: 0 24px;
  border-bottom: 1px solid ${token("colors.border.outline")};
  flex-shrink: 0;
`;
